import type { IAPI } from '../../apiResponse';
import { getRequest, type IRequestOptions } from '../../httpClient';
import {
  type IListPublicChallengeClipsBySlugV2ResponseData,
  listPublicChallengeClipsBySlugV2ResponseSchema,
} from './list-public-challenge-clips-by-slug-v2-response';

export async function listPublicChallengeClipsBySlugV2Api(
  slug: string,
  limit?: number,
  options?: IRequestOptions,
) {
  const query = limit ? `?limit=${limit}` : '';
  return getRequest<IAPI<IListPublicChallengeClipsBySlugV2ResponseData>>({
    path: `/challenges/v3/slug/${encodeURIComponent(slug)}/clips/v2${query}`,
    options,
    schema: listPublicChallengeClipsBySlugV2ResponseSchema,
  });
}
